import React from "react";

import { useField, useFormikContext } from "formik";

import { Label, TextArea } from "components/Form/FormikControls";
import { DateInput } from "components/Form";
import { withNamespace } from "components/Form/FormikControls/lib";
import theme from "constants/theme";
import { FormRow } from "./FormRow";
import { Grid } from "@material-ui/core";
import { MobileTransactionalCreateSaleFormValues } from "components/MobileTransactionalModal/lib/types";

const dateInputStyle = { backgroundColor: theme.colors.white };

interface DeliveryFieldsProps {
  consignmentNamespace: string;
}

const DeliveryFields = ({ consignmentNamespace }: DeliveryFieldsProps) => {
  const { values } =
    useFormikContext<MobileTransactionalCreateSaleFormValues>();
  const isCarrierSet = !!values.consignment?.carrierCharge?.carrier;

  const [field, meta] = useField(
    withNamespace(consignmentNamespace, "carrierCharge.deliveryDate"),
  );

  return (
    <>
      <FormRow>
        <Grid item xs={12}>
          <Label error={meta.touched && !!meta.error}>Delivery Date</Label>
          <DateInput
            {...field}
            error={meta.touched && !!meta.error}
            includeTime={false}
            style={dateInputStyle}
          />
        </Grid>
      </FormRow>
      <FormRow>
        <Grid item xs={12}>
          <TextArea
            label="Delivery Notes"
            name={withNamespace(consignmentNamespace, "carrierCharge.notes")}
            rows={3}
            required={isCarrierSet}
          />
        </Grid>
      </FormRow>
    </>
  );
};

interface WhenTabProps {
  saleNamespace: string;
  consignmentNamespace?: string;
}

export const WhenTab = ({
  saleNamespace,
  consignmentNamespace,
}: WhenTabProps) => {
  const [field, meta] = useField(withNamespace(saleNamespace, "date"));

  return (
    <Grid container>
      <FormRow>
        <Grid item xs={12}>
          <Label required error={meta.touched && !!meta.error}>
            Sale Date
          </Label>
          <DateInput
            {...field}
            error={meta.touched && !!meta.error}
            includeTime={false}
            style={dateInputStyle}
          />
        </Grid>
      </FormRow>
      {consignmentNamespace && (
        <DeliveryFields consignmentNamespace={consignmentNamespace} />
      )}
    </Grid>
  );
};
